

export function isOnlyAlphabets(value: string) {
  return new RegExp(/^[A-Za-z\s]+$/).test(value)
}

export function isOnlyNumbers(value: string) {
  return new RegExp(/^[0-9]+$/).test(value)
}
export function isOnlyAlphabetsNumbers(value: string) {
  return new RegExp(/^[a-zA-Z0-9 ]+$/).test(value)
}

export function isWebsiteAddress(value: string) {
  return new RegExp(/^(https?:\/\/(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+|[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]*)?$/).test(value)
}
export function isYouTubeUrl(value: string) {
  return new RegExp(/^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/).test(value)
}

export function normalizeUrl(url: string) {
  // Create a URL object to handle the URL parsing
  const urlObject = new URL(url);

  // Normalize by returning hostname and pathname in lowercase
  return `${urlObject.hostname}`.toLowerCase();
}


export function formatDate(datetime: string) {
  const date = new Date(datetime);


  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  const formattedDate = date.toLocaleString(undefined, options);
  return formattedDate
}

export function normalizeMarkdown(content: string): string {
  return content
    .replace(/^--\s*/gm, '- ')                  // Replace malformed unordered list
    .replace(/^(\d+)\.(\S)/gm, '$1. $2')         // Fix numbered list
    .replace(/^(\*|\+)\s*/gm, '- ')              // Normalize other bullets
    .replace(/^(#{1,6})([^\s#])/gm, '$1 $2')     // Add space in headings
    .replace(/\n{3,}/g, '\n\n')                  // Collapse triple newlines
    .trim();
}

export function capitalizeFirstLetter(str: string ) {
  if (!str) return "";
  var newStr =  str.charAt(0).toUpperCase() + str.slice(1);
  newStr = newStr.replace(/[^a-zA-Z0-9]+/g, ' ').trim();
  return newStr;
}




export function generateIframeBubbleCode(RedirectUrl: string, agentId: string, path: string) {
  const url = `${RedirectUrl}${path}/${agentId}/PLACE YOUR API_KEY`
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Chatbot Integration</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body {
      margin: 0;
      font-family: Arial, sans-serif;
    }
  </style>
</head>
<body>

  <!-- Chatbot iframe (replace PLACE YOUR API_KEY with your actual key) -->
  <iframe 
  src=${url} 
  id="chatbot-frame" 
  width="480" 
  height="600" 
  frameborder="0" 
  style="
    height: 80vh;
    width: 480px;
    min-width: 320px;
    max-width: 95vw;
    max-height: 90vh;
    position: fixed;
    right: 40px;
    bottom: 100px;
    z-index: 99999;
    display: none;
    border-radius: 28px;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
    border: none;
    background: white;
    overflow: hidden;
  ">
</iframe>

  <!-- Button to toggle chatbot visibility -->
 <button 
  id="loadBotButton" 
  onclick="toggleBot()" 
  style="position: fixed; right: 40px; bottom: 40px; z-index: 999990; width: 48px; height: 48px; border-radius: 50%; border: none; cursor: pointer; background: none; box-shadow: 1px 1px 23px -11px rgba(0,0,0,0.21);">
  <img src="https://zeaiq.zeacat.com/logo-icon.png" width="100%" alt="Chatbot Icon">
</button>

  <!-- Toggle script -->
  <script>
    function toggleBot() {
      var iframe = document.getElementById("chatbot-frame");
      iframe.style.display = iframe.style.display === "none" ? "block" : "none";
    }
  </script>

</body>
</html>
    `;
}


//  old

export function generateIframeCode(RedirectUrl: string, token: string, agentId: string) {
  const url = `${RedirectUrl}iframe/${token}/${agentId}`
  return `<iframe
     src=${url}
      width="100%"
      style="height: 100%; min-height: 700px"
      frameBorder="0"
    ></iframe>`;


}
